import styled, { css } from "styled-components";
import { Button } from "src/components";

export const PageWrapper = styled.div`
  background-color: #0e0f10;
  height: 100vh;
  display: grid;
  padding: 24px 24px 24px 60px;

  @media (max-width: 768px) {
    padding: 24px 24px 24px 30px;
  }

  @media (min-width: 1330px) {
    grid-gap: 100px;
    grid-template-columns: 40% auto;
  }

  @media (min-width: 1920px) {
    grid-template-columns: 45% 45%;
  }
`;

export const ContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (min-width: 1920px) {
    align-items: flex-end;
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  flex-shrink: 0;
  border-radius: 5px;
  width: 100%;
  max-width: 487px;

  .logo {
    img {
      height: 58px;
      margin-bottom: 60px;

      @media (max-width: 768px) {
        margin-bottom: 40px;
      }
    }
  }

  .form {
    width: 100%;
  }

  h1 {
    color: #ffffff;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    @media (max-width: 320px) {
      font-size: 20px;
    }
  }

  h3 {
    color: #ffffff;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 48px;

    @media (max-width: 320px) {
      font-size: 14px;
    }
  }

  .action {
    width: 100%;
    margin-top: 32px;

    button {
      cursor: pointer;
      height: 64px;
      width: 100%;
      border: 0;
      background-color: #00c6c9;
      border-radius: 4px;
      color: #202428;
      font-size: 18px;
      text-transform: capitalize;
      font-weight: 700;
      line-height: normal;

      &:hover {
        background-color: #0da8a4;
      }

      &:active {
        background-color: #16e0da;
      }
    }
  }

  a {
    color: #ffffff;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    &:hover {
      text-decoration-line: underline;
    }
  }

  @media (min-width: 1920px) {
    align-self: flex-end;
  }
`;

export const IconWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
`;

export const IconBtn = styled.div`
  svg path {
    stroke: #495f6e;
  }

  svg.eyeIcon {
    position: absolute;
    right: 17px;
    top: calc(50% - 7px);
    width: 20px;
    height: 14px;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100vh;

  img {
    min-height: 100%;
    max-height: 90vh;
    width: 100%;
    max-width: 100%;
    object-fit: cover;
    border-radius: 24px;
  }

  @media (max-width: 1334px) {
    display: none;
  }
`;

export const InputField = styled.div`
  width: 100%;
  margin-bottom: 16px;

  input {
    width: 100%;
    padding: 20px;
    border-radius: 4px;
    border: 0;
    height: 50px;

    color: #202428 !important;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;

    border-radius: 4px;
    border: 1px solid ${(props) => (props.isValid ? "#DFDFDF" : "#EB5757")};

    &::placeholder {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 21px;
      color: #6b7986 !important;
    }
  }

  .errorMessage {
    color: #eb5757;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 4px;
    padding-left: 0;
  }
`;

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
  gap: 2px;
  position: absolute;
  bottom: 30px;
  align-items: center;

  span {
    color: #FFF;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    @media (max-width: 425px) {
      font-size: 10px;
    }
  }
`;

export const CheckboxWrapper = styled.span`
  ${({ disabled }) =>
    disabled
      ? css`
          cursor: not-allowed;
        `
      : ""}
`;

export const CheckboxButton = styled(Button)`
  cursor: pointer;

  ${({ disabled }) =>
    disabled
      ? css`
          pointer-events: none;
        `
      : ""}

  padding: 5px 0px;
  height: 20px;
  width: 20px;
  margin-right: 2px;
  background-color: transparent;

  &:hover {
    background-color: transparent;
    color: transparent;
  }

  ${(props) => ({
    display: props.isBolded ? "none" : "",
  })}
`;

export const OptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    cursor: pointer;
  }
`;

export const CheckboxText = styled.h4`
  color: #dfdfdf;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 2px;
`;

export const Square = styled.span`
  width: 14px;
  height: 14px;
  border-radius: 2.28571px;
  border: 1px solid ${(props) => props.theme.colors.text.default};
  display: inline-block;
  background: transparent;
  box-sizing: border-box;
  position: relative;

  ${(props) =>
    props.isChecked
      ? `
    :before,
  :after {
    content: "";
    position: absolute;
    display: block;
    height: 10px;
    width: 2px;
    background: ${props.theme.colors.secondary};
  }

  :after {
    transform: rotate(45deg);
    left: 6.7px;
    top: 0.5px;
  }
  :before {
    height: 6px;
    transform: rotate(-45deg);
    left: 2px;
    top: 3.8px;
  }
  `
      : ""}
`;

export const LgpdDocuments = styled.div`
  display: flex;
  gap: 8px;

  a {
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    line-height: normal;
    text-align: center;
    color: ${(props) => props.theme.colors.normalButtonTextColor};
    cursor: pointer;

    @media (max-width: 425px) {
      font-size: 10px;
    }
  }

  span {
    color: ${(props) => props.theme.colors.normalButtonTextColor};
  }
`;
